import { GoogleCalendar } from '@/assets/icons/calendar';
import { Microsoft } from '@/assets/icons/mailbox';
import { ConnectWithCalForm } from '@/components/calendar/ConnectWithCalForm';
import { selectCurrUser } from '@/store/bootstrap/selectors';
import { Button, Flex, Icon } from '@chakra-ui/react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useDispatch, useSelector } from 'react-redux';
import { ModalWrapper } from '../modal';

// Todo - change this later as extensible
export const OauthModal = ({
  isOpen,
  onClose,
  hideOutlookCalendar = false,
  headerText = 'Please link your calendar',
  subHeaderText = 'Connect your calendar to display both your availability and your interviewers for scheduling interviews',
}) => {
  const dispatch = useDispatch();
  const currUser = useSelector(selectCurrUser);
  const { feOutlookCalendarIntegration } = useFlags();

  return (
    <ModalWrapper
      isOpen={isOpen}
      onClose={onClose}
      headerText={headerText}
      subHeaderText={subHeaderText}
      showFooter={false}
      modalBodyProps={{ pb: '24px' }}
      BodyBlock={() => (
        <Flex gap="12px" flexDir="column">
          <ConnectWithCalForm
            variant="gcal"
            user={currUser}
            dispatch={dispatch}
          >
            <Button
              type="submit"
              variant="secondary"
              leftIcon={<Icon as={GoogleCalendar} />}
              disabled={false}
              data-test-id="settings-connect-cal-google"
              width="full"
            >
              Connect your Google Calendar
            </Button>
          </ConnectWithCalForm>
          {feOutlookCalendarIntegration && !hideOutlookCalendar && (
            <ConnectWithCalForm
              variant="mscal"
              user={currUser}
              dispatch={dispatch}
            >
              <Button
                type="submit"
                variant="secondary"
                leftIcon={<Microsoft />}
                disabled={false}
                data-test-id="settings-connect-cal-ms"
                width="full"
              >
                Connect your Outlook Calendar
              </Button>
            </ConnectWithCalForm>
          )}
        </Flex>
      )}
    />
  );
};
